module.exports = __webpack_public_path__ + "img/followers.1c022a74.png";